import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export enum EPaymentTypeIds {
    DEFAULT = 'default',
    WHOLESALE = 'wholesale',
}

export type TSetPaymentTypeId = IAction<EPaymentActions.SET_PAYMENT_TYPE_ID, EPaymentTypeIds>

const setPaymentTypeId = (id: EPaymentTypeIds): TSetPaymentTypeId => ({
    type: EPaymentActions.SET_PAYMENT_TYPE_ID,
    payload: id,
});

export default setPaymentTypeId;
